__webpack_require__.p = "/MYOGITHAREDDY_PORTFOLIO/";